module.exports = __webpack_public_path__ + "static/img/1.bb4b9df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/1.png
// module id = 16ln
// module chunks = 0